export const DOCUMENT_CLIENT_PARAM = "client";

export function documentDeepLink(documentId: string, businessId: string): string {
    const client = new URLSearchParams({ [DOCUMENT_CLIENT_PARAM]: businessId });
    return `/documents/${encodeURIComponent(documentId)}?${client.toString()}`;
}

export function isDocumentDeepLink(search: string): boolean {
    return new URLSearchParams(search).has(DOCUMENT_CLIENT_PARAM);
}
